import desktopBg from "../pages/images/desktop/desktop.jpg";

/** SweetAlert — game background image, dark text (not white popup). */
export function swalTabooTheme(overrides = {}) {
  return {
    background: `#f5f0e6 url(${desktopBg}) center center / cover no-repeat`,
    color: "#1a1a1a",
    confirmButtonColor: "#3bb5a8",
    cancelButtonColor: "#243b6b",
    customClass: {
      popup: "swal-taboo-popup",
      title: "swal-taboo-title",
      htmlContainer: "swal-taboo-html",
      confirmButton: "swal-taboo-confirm",
      ...overrides.customClass,
    },
    ...overrides,
  };
}
